import type { CreateQueryClientOptions } from '@zg-rentals/react-query5';

import { isPerimeterXBlockedError } from '@/src/lib/api/client/apiClient';

function isExpectedMessagesUnauthorized(error: Error, queryMeta?: { context?: Record<string, unknown> }): boolean {
  return (
    error.name === 'DatarouterError' &&
    'responseStatus' in error &&
    error.responseStatus === 401 &&
    queryMeta?.context?.api === 'satellite-api' &&
    (queryMeta.context.details === 'getMessages' || queryMeta.context.details === 'getLatestConversations')
  );
}

export const queryClientOptions = {
  shouldLogQueryError: (error, _queryKey, queryMeta) =>
    !isPerimeterXBlockedError(error) && !isExpectedMessagesUnauthorized(error, queryMeta),
} satisfies CreateQueryClientOptions;
